<template>
  <div class="crypto-section">
    <div class="amount-container">
      <v-select class="select"
                :clearable="false"
                :searchable="false"
                :options="currencyValues"
                @input="chooseCurrency($event)"
                :value="takeCurrency.crypto_currency"
                placeholder="Country"
      >
        <template #selected-option="{ label }">
          <div>
            <strong>{{ label.toUpperCase() }}</strong>
          </div>
        </template>
      </v-select>
      <input :value="takeAmount" @input="$emit('update:take-amount',  $event.target.value); changeGiveAmount($event.target.value);" type="text" class="input">
    </div>

<!--    {{ currencyValues }}-->

<!--    {{ giveCurrency }}-->

<!--    {{ filteredRatesUsd }}-->

<!--    <div v-if="!$parent.fiatToCrypto" class="radio-list payment-method-list">-->
<!--      <div class="desc">Payment method:</div>-->
<!--      <div class="list">-->
<!--        <div class="item">-->
<!--          <label>-->
<!--            <input type="radio" v-model="paymentMethod" @change="$emit('update:payment-method', $event)" name="paymentMethod" value="crypto"/>-->
<!--            <div class="text">-->
<!--              <div class="desc">Crypto</div>-->
<!--            </div>-->
<!--          </label>-->
<!--        </div>-->
<!--      </div>-->
<!--    </div>-->
<!--    <div class="radio-list cryptocurrency-list">-->
<!--      <div class="list" v-if="rates && giveCurrency.title == 'Euro'">-->
<!--        <div class="desc title align-left">Assets:</div>-->
<!--        <div class="item" v-for="item in filteredRatesEur" :key="item.id">-->
<!--          <label>-->
<!--            <input type="radio" :checked="takeCurrency.crypto_currency === item.crypto_currency"  @change="$emit('update:take-currency', item)" :value="item.crypto_currency" />-->
<!--            <div class="text">-->
<!--              <div class="desc">{{item.crypto_currency}}</div>-->
<!--              <div class="desc">{{item.price}} : 1</div>-->
<!--            </div>-->
<!--          </label>-->
<!--        </div>-->
<!--      </div>-->
<!--      <div class="list" v-if="rates && giveCurrency.title == 'US dollar'">-->
<!--        <div class="item" v-for="item in filteredRatesUsd" :key="item.id">-->
<!--          <label>-->
<!--            <input type="radio" :checked="takeCurrency.crypto_currency === item.crypto_currency"  @change="$emit('update:take-currency', item)" :value="item.crypto_currency" />-->
<!--            <div class="text">-->
<!--              <div class="desc">{{item.crypto_currency}}</div>-->
<!--              <div class="desc">{{item.price}} : 1</div>-->
<!--            </div>-->
<!--          </label>-->
<!--        </div>-->
<!--      </div>-->
<!--    </div>-->
  </div>
</template>

<script>
import vSelect from "vue-select";

export default {
  name: 'CryptoSection',
  components: {
    vSelect
  },
  props: {
    giveCurrency : {
      type: Object
    },
    rates: {
      type: Array
    },
    filteredRatesEur: {
      type: Array
    },
    filteredRatesUsd: {
      type: Array
    },
    takeCurrency: {
      type: Object
    },
    takeAmount: {
      type: Number
    },
    changeGiveAmount: {
      type: Function
    },
    toggleFiatToCrypto: {
      type: Function
    },
    paymentMethod: {
      type: String
    }
  },
  data: function() {
    return {}
  },
  methods: {
    chooseCurrency(event) {
      const currency = this.computedRates.find(({crypto_currency}) => crypto_currency === event.code);
      console.log(event, 'crypto currency', currency.code);
      this.$emit('update:take-currency', currency);
    }
  },
  computed: {
    computedRates() {
      if (this.giveCurrency.code === 'USD') {
        return this.filteredRatesUsd;
      } else if(this.giveCurrency.code === 'EUR') {
        return this.filteredRatesEur;
      }

      return [];
    },
    currencyValues() {
      return this.computedRates.map(({crypto_currency}) => ({code: crypto_currency, label: crypto_currency.toUpperCase()}));
    }
  },
  mounted() {}
}
</script>
